module.exports = __webpack_public_path__ + "img/4H.6695f1d5.png";